// extracted by mini-css-extract-plugin
export default {"avatar":"egFptUl","avatar--clickable":"A_o2rZg"};